import { Mail, MapPin, Phone } from "lucide-react";
import { Overline, SectionHeading } from "@/components/Section";
import LeadForm from "@/components/LeadForm";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="section-pad">
        <div className="container-tib grid lg:grid-cols-2 gap-16">
          <div>
            <SectionHeading
              overline="Contact"
              title="Talk to the build engine."
              body="Questions about a platform, a partnership, or the portfolio? Send a note and the TIB team will get back to you."
            />
            <div className="mt-10 space-y-6">
              <div className="flex gap-4 items-start" data-testid="contact-phone">
                <Phone className="w-5 h-5 text-tib-gold mt-1" strokeWidth={1.4} />
                <div>
                  <div className="overline mb-1">Call or text</div>
                  <a href="tel:+18887888450" className="text-white hover:text-tib-gold">(888) 788-8450</a>
                  <p className="text-zinc-500 text-sm mt-1">Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help.</p>
                </div>
              </div>
              <div className="flex gap-4 items-start" data-testid="contact-email">
                <Mail className="w-5 h-5 text-tib-amber mt-1" strokeWidth={1.4} />
                <div>
                  <div className="overline mb-1">Email</div>
                  <a href="mailto:hello@techinnovationbuilders.com" className="text-white hover:text-tib-amber">hello@techinnovationbuilders.com</a>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <MapPin className="w-5 h-5 text-tib-amber mt-1" strokeWidth={1.4} />
                <div>
                  <div className="overline mb-1">Entity</div>
                  <p className="text-zinc-300">TechInnovationBuilders.com, LLC<br />A division of MPGBusinessFunding.com, LLC</p>
                </div>
              </div>
            </div>
          </div>
          <div className="card-edge p-8">
            <Overline className="mb-6">Send a message</Overline>
            <LeadForm inquiryType="contact" />
          </div>
        </div>
      </section>
    </div>
  );
}
